module.exports = __webpack_public_path__ + "assets/okta.86b0a1bb.svg";